import type { Livello, Segmento } from "../lib/log-ansi.ts";
import { cx } from "./ui.tsx";

/**
 * Resa di una riga di log già spezzata in segmenti ANSI, condivisa dai log dei
 * container e dalla console del rilascio.
 */

/** Tavolozza ANSI a 16 colori, tarata sullo sfondo scuro della console. */
const ANSI = [
  "text-zinc-500", "text-rose-400", "text-emerald-400", "text-amber-300",
  "text-sky-400", "text-fuchsia-400", "text-cyan-400", "text-zinc-200",
  "text-zinc-400", "text-rose-300", "text-emerald-300", "text-yellow-200",
  "text-sky-300", "text-fuchsia-300", "text-cyan-300", "text-white",
];

/** Bordo sinistro e fondo della riga secondo il suo livello. */
export const STILE_LIVELLO: Record<Livello, string> = {
  errore: "border-rose-500 bg-rose-500/10 text-rose-200",
  avviso: "border-amber-400 bg-amber-400/5 text-amber-100",
  info: "border-sky-500/40",
  debug: "border-transparent opacity-60",
};

/** Spezza il testo sulle occorrenze di `cerca`, senza distinguere maiuscole. */
function evidenzia(testo: string, cerca: string) {
  if (!cerca) return testo;

  const parti: (string | React.ReactElement)[] = [];
  const basso = testo.toLowerCase();
  let da = 0;

  for (let i = basso.indexOf(cerca); i !== -1; i = basso.indexOf(cerca, da)) {
    parti.push(testo.slice(da, i));
    parti.push(
      <mark key={i} className="rounded-sm bg-yellow-300/80 text-black">
        {testo.slice(i, i + cerca.length)}
      </mark>,
    );
    da = i + cerca.length;
  }

  parti.push(testo.slice(da));
  return parti;
}

/**
 * I segmenti con il loro colore, e le occorrenze della ricerca evidenziate.
 *
 * `cerca` va passato già in minuscolo.
 */
// ponytail: un'occorrenza che attraversa due segmenti di colore diverso non si evidenzia (la riga resta comunque nel filtro)
export function TestoAnsi({ segmenti, cerca = "" }: { segmenti: readonly Segmento[]; cerca?: string }) {
  return segmenti.map((s, j) => (
    <span
      key={j}
      className={cx(s.colore !== null && ANSI[s.colore], s.grassetto && "font-semibold", s.tenue && "opacity-60")}
    >
      {evidenzia(s.text, cerca)}
    </span>
  ));
}
